import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/logo_icon.svg'
import _imports_1 from '@/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-d6baba28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal p-3 text-center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_calendar = _resolveComponent("calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_6)
      ])
    ]),
    (_ctx.centro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.centro.personalData.completeName), 1)
          ]),
          (_ctx.availabilities[0] && _ctx.availabilities[0].isVideoCall)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "L'appuntamento si svolgerà tramite videochiamata",
                  text: "L'appuntamento si svolgerà tramite videochiamata"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.availabilities[0] && _ctx.availabilities[0].address.completeAddress), 1)),
          _createVNode(_component_calendar, {
            class: "month smallCalendar mt-4",
            "show-mode-changer": false,
            "scroll-to-hour": false,
            "start-mode": 'month'
          }, {
            default: _withCtx((data) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.days, (day, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["calendarDay", day.classes]),
                  key: i
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(day.date, 'DD')), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["box pointer", { 'bg-green': _ctx.getFasceOfDay(day).length > 0}]),
                    onClick: ($event: any) => (_ctx.selectDate(day))
                  }, _toDisplayString(_ctx.getFasceOfDay(day).length || '-'), 11, _hoisted_10)
                ], 2))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("b", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Seleziona un giorno per vedere gli orari disponibili",
                text: "Seleziona un giorno per vedere gli orari disponibili"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}